export default __webpack_public_path__ + "static/media/Hair_15_F_C1.c3259a10.svg";